import { Metric, onCLS, onINP, onLCP } from 'web-vitals';

import { track } from '@/bundles/Analytics/helpers/gtm';
import { AnalyticsEventEnum } from '@/bundles/Analytics/types';

function reportWebVital ({ name, value, rating }: Metric): void {
  track(AnalyticsEventEnum.WebVital, {
    metric_name: name,
    // CLS is a unitless score; LCP and INP are milliseconds
    metric_value: name === 'CLS' ? Math.round(value * 1000) / 1000 : Math.round(value),
    metric_rating: rating,
  });
}

// LCP is measured once per load, so it belongs to the page the app was opened on. INP and CLS
// cover the whole visit and are reported when the tab is hidden, under the page shown then.
export function trackWebVitals (): void {
  onLCP(reportWebVital);
  onINP(reportWebVital);
  onCLS(reportWebVital);
}
